import { makeStyles } from "tss-react/mui";
import { FormControlLabel, Switch } from "@mui/material";

const useStyles = makeStyles()(() => ({
  switch: { width: "100%", margin: 0 },
}));

export function MiSwitch({
  label = "",
  name = "",
  value,
  handleChange,
  disabled,
}) {
  const { classes } = useStyles();

  return (
    <FormControlLabel
      className={classes.switch}
      data-testid={`mi-switch-${name}`}
      control={<Switch checked={!!value} onChange={handleChange} />}
      label={label}
      disabled={disabled}
    />
  );
}
